import { render } from "./AppNavAlert.vue?vue&type=template&id=e07c3b0a&scoped=true&ts=true"
import script from "./AppNavAlert.vue?vue&type=script&lang=ts"
export * from "./AppNavAlert.vue?vue&type=script&lang=ts"

import "./AppNavAlert.vue?vue&type=style&index=0&id=e07c3b0a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e07c3b0a"]])

export default __exports__